export const isValidFile = (file: File): boolean => {
  if (file.size === 0 && file.type === '') {
    return false;
  }
  return file.type !== '' || file.size > 0;
};

const checkForFoldersInItems = (items: DataTransferItemList): boolean => {
  for (const item of Array.from(items)) {
    if (item.kind === 'file') {
      try {
        const entry = item?.webkitGetAsEntry?.();
        if (entry && entry.isDirectory) {
          return true;
        }
      } catch (e) {
      }
    }
  }
  return false;
};

const checkForFolderLikeFiles = (files: File[]): boolean => {
  return files.some(file => file.size === 0 && file.type === '');
};

export const hasFoldersInDataTransfer = (dataTransfer: DataTransfer): boolean => {
  if (checkForFoldersInItems(dataTransfer.items)) {
    return true;
  }

  if (dataTransfer.files.length > 0) {
    const files = Array.from(dataTransfer.files);
    return checkForFolderLikeFiles(files);
  }

  return false;
};

export const validateDroppedFiles = (files: File[]): { isValid: boolean; errorMessage?: string } => {
  if (files.length === 0) {
    return { isValid: false, errorMessage: "No files were dropped. Please try again." };
  }

  const invalidFiles = files.filter(file => !isValidFile(file));
  if (invalidFiles.length > 0) {
    return { isValid: false, errorMessage: "Some files are not supported. Please drop valid files (images, documents, etc.)." };
  }

  return { isValid: true };
};

export const checkDragItems = (dataTransfer: DataTransfer): { isValid: boolean; hasFolders: boolean } => {
  const hasFolders = hasFoldersInDataTransfer(dataTransfer);
  
  if (hasFolders) {
    return { isValid: false, hasFolders: true };
  }

  if (dataTransfer.files.length > 0) {
    const files = Array.from(dataTransfer.files);
    const allValid = files.every(isValidFile);
    return { isValid: allValid, hasFolders: false };
  }

  const hasFileItems = Array.from(dataTransfer.items).some(item => item.kind === 'file');
  return { isValid: hasFileItems && !hasFolders, hasFolders };
};

